import React, { FC } from "react";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import QuestionMarkOutlinedIcon from "@mui/icons-material/QuestionMarkOutlined";
import { useMediaQuery } from "react-responsive";
import { ScreenSize } from "@constants/screen-size";

const Container = styled.div`
  display: flex;
  gap: 16px;
`;

const HeaderActions: FC = () => {
  const { t } = useTranslation();
  const isSmScreen = useMediaQuery({
    query: `(max-width: ${ScreenSize.md}px)`,
  });
  function showHelp() {
    // Open chat directly; launcher visibility is controlled centrally by
    // route/form-factor logic (HomeRoutes).
    window.Argoli.Brevo.showHelp();
  }

  return (
    <Container>
      {!isSmScreen && (
        <IconButton
          size="small"
          aria-label={t("header.helpButton")}
          onClick={showHelp}
        >
          <QuestionMarkOutlinedIcon />
        </IconButton>
      )}
    </Container>
  );
};

export default HeaderActions;
